import { combineReducers } from 'redux';
import report, { ReportsState } from './reports';
import dictionaries, { DictionariesState } from './dictionaries';
import user, { UserState } from './user';
import issueTemplates, { IssueTemplatesState } from './issueTemplates';

export interface AppState {
    report: ReportsState;
    dictionaries: DictionariesState;
    user: UserState;
    issueTemplates: IssueTemplatesState;
}

export default combineReducers<AppState>({
    report,
    dictionaries,
    user,
    issueTemplates
});
